<template>
  <b-container class="admin-requests-container">
    <b-alert
      :show="dismissCountDown && !showInnerAlert"
      fade
      dismissible
      variant="success"
      @dismissed="
      dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <p style="margin: 0">已複製 {{ copyType | alertType }} 到剪貼簿</p>
    </b-alert>

    <h1>客戶訊息</h1>

    <b-table
      v-if="requests.length"
      class="mission-table-component-container"
      head-variant="dark"
      sticky-header
      hover
      striped
      :fields="fields"
      :items="requests"
    >
      <template v-slot:cell(mail)="data">
        <p class="request-p">
          {{ data.value }}
        </p>
        <b-icon-envelope
          v-b-tooltip.right.hover
          title="複製 Email"
          @click="copyCodeToClipboard('mail', data.item, false)"
        />
      </template>

      <template v-slot:cell(createAt)="data">
        <p>{{ moment(data.value)}}</p>
      </template>

      <template v-slot:cell(request)="data">
        <p @click="showModal(data.item.id)" class="request-p requestMsg">
          {{ data.value | subString }}
        </p>
        <b-icon-files
            v-b-tooltip.right.hover
            title="複製客戶留言"
            @click.stop="copyCodeToClipboard('request', data.item, false)"
          />
      </template>
    </b-table>
    
    <b-modal
      id="modal-1"
      title="Client Request"
    >
      <b-list-group v-if="focusRequestId">
        <b-list-group-item
          class="d-flex justify-content-between align-items-center"
          href="#"
          @click="copyCodeToClipboard('mail', filterById, true)"
        >
          <b-icon icon="envelope" scale="2" variant="info"></b-icon>
          {{filterById.mail}}
        </b-list-group-item>

        <b-list-group-item
          href="#"
          @click="copyCodeToClipboard('request', filterById, true)"
        >
          <span v-html="transformBreak(filterById.request)" />
        </b-list-group-item>
      </b-list-group>

      <template v-slot:modal-footer>
        <div class="w-100">
          <b-alert
            :show="dismissCountDown && showInnerAlert"
            fade
            dismissible
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            <p style="margin: 0">已複製 {{ copyType | alertType }} 到剪貼簿</p>
          </b-alert>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>


<script>
  import { mapActions, mapState } from "vuex";
  import moment from 'moment';

  export default {
    data() {
      return {
        fields: [
          { key: "name", label: "公司名稱" },
          { key: "mail", label: "連絡信箱" },
          { key: "request", label: "訊息內容" },
          { key: "createAt", label: "日期" },
        ],
        dismissSecs: 2,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        focusRequestId: '',
        copyType: '',
        showInnerAlert: false,
      };
    },
    computed: {
      ...mapState("backend", ["requests"]),

      filterById() {
        if (this.requests.length) {
          return this.requests.filter(doc => doc.id === this.focusRequestId)[0];
        }
        return;
      }
    },
    methods: {
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown;
      },
      showAlert(type, isInner) {
        this.showInnerAlert = isInner;
        this.copyType = type;
        this.dismissCountDown = this.dismissSecs;
      },
      copyCodeToClipboard(type, data, isInner) {
        const createAtDate = moment(data.createAt.toDate()).format("MM/DD/YYYY");
        const divider = Array(60).fill('=').join('');
        const copyText = type === 'request'
          ? `Hello, we got the message from you in www.soonport.com at ${createAtDate}: \n ${divider} \n ${data.request}`
          : data.mail
        navigator.clipboard.writeText(copyText);
        this.showAlert(type, isInner);
      },
      showModal: function (id) {
        this.focusRequestId = id;
        this.$bvModal.show("modal-1");
      },
      transformBreak: function (string) {
        return string.replace(/\n/g, '<br>');
      },
      moment(timestamp) {
        return moment(timestamp.toDate()).format("YYYY-MM-DD HH:mm");
      }
    },
    filters: {
      subString: (string) => string.length>50 ? string.substr(0, 50) + "..." : string,
      alertType: (type) => {
        switch (type) {
          case 'mail':
            return '連絡信箱';
          case 'request':
            return '客戶留言';
          default:
            return '訊息';
        }
      }
    },
  };
</script>
